<script setup lang="ts">
import './box.css';

defineProps({
  use: {
    type: String,
    default: 'div',
  },

  border: {
    type: [Boolean, String],
    default: null,
  },

  spacing: {
    type: [Number, String],
    default: null,
  },

  solid: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <component
    :is="use"
    :class="[
      'phxsg-box',
      {
        'phxsg-box--solid': solid,
        [`phxsg-box--spacing-${spacing}`]: spacing,
        'phxsg-box--border': border === true,
        [`phxsg-box--border-${border}`]: typeof border === 'string',
      },
    ]"
  >
    <slot />
  </component>
</template>
